import React, { CSSProperties, useState } from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ExcelDownloadModal } from '../Modals/ExcelDownloadModal/ExcelDownloadModal';
import { ReactComponent as IconDownloadAlt } from '../../../assets/icons/u_download-alt.svg';
import './ExcelDownloadButton.scss';
import { useTranslation } from 'react-i18next';


interface Props {
  selectedRow?: string;
  headers: string[];
  selectedKeys: string[];
  addClass?: CSSProperties;
  dataExcel: any;
}


const currentDay = new Date().toDateString();

export const ExcelDownloadButton: React.FC<Props> = ({ selectedRow, headers, selectedKeys, dataExcel }) => {
  const [error, setError] = useState<string | boolean | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const { t } = useTranslation();
  const hasDataToDownload = Array.isArray(dataExcel) && dataExcel.length > 0;

  const errorMsg = {
    title: `${t('download_excel')}`,
    subtitleMsg: {
      sub1: `${t('failed_download_document')}`,
      sub2: `${t('please_try_again')}`
    }
  }

  // TODO: pendiente funcion para extraer nombre
  const cancelDownload = () => setError(null);

  const transformDataForExcel = (data) => {
    const translatedHeaders = headers.map(header => t(header));

    return data.map(item => {
      let transformedItem = {};
      translatedHeaders.forEach((header, index) => {
        const originalHeader = headers[index];
        transformedItem[header] = item[originalHeader] ?? 'N/A';
      });
      return transformedItem;
    });
  };

  const handleDownload = () => {
    if (!hasDataToDownload) {
      return;
    }

    try {
      const wsData = transformDataForExcel(dataExcel);
      const ws = XLSX.utils.json_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "project name");

      const binaryString = XLSX.write(wb, { bookType: 'xls', type: 'binary' });
      const buffer = new ArrayBuffer(binaryString.length);
      const view = new Uint8Array(buffer);

      for (let i = 0; i < binaryString.length; i++) {
        view[i] = binaryString.charCodeAt(i) & 0xFF;
      }

      const blob = new Blob([view], { type: 'application/vnd.ms-excel' });
      saveAs(blob, `${currentDay}.xls`);
      setError(null);
    } catch (error) {
      if (error instanceof Error) {
        setError(errorMsg.title);
      } else {
        setError(`${t('unknown_error_downloading_file')}`);
      }
      setShowModal(true)
    };
  };

  const initiateDownload = () => {
    setShowModal(false);
    setTimeout(() => {
      handleDownload();
    }, 500);
  };

  const retryDownload = () => {
    setError(null);
    initiateDownload();
  };

  const handleCloseModal = () => {
    setShowModal(false)
    setError(null)
  }

  return (
    <>
      <div className="c-donwload-btn c-donwload-btn-prov" style={{ zIndex: 3 }}>
        <button
          className="btn-primary-text download-excel"
          onClick={handleDownload}
          disabled={!hasDataToDownload}
        >
          <IconDownloadAlt /> <span> {t('download_excel')}</span>
        </button>
        {error && (
          <ExcelDownloadModal
            isOpen={showModal}
            closeModal={handleCloseModal}
            retryDownload={retryDownload}
            cancelDownload={cancelDownload}
            errorMsg={errorMsg}
          />
        )}
      </div>
    </>
  );
}
